'use client';

import React from 'react';
import { useSection, UseSectionProps } from './useSection';
import { SectionProvider } from './useSectionContext';
import { type SectionHeadReturn } from './SectionHead';
import { type SectionItemReturn } from './SectionItem';
import { type SectionStackReturn } from './SectionStack';

type AllowChildrenForSectionComponent =
    | SectionHeadReturn
    | SectionItemReturn
    | SectionStackReturn;

interface SectionProps extends UseSectionProps {
    children: AllowChildrenForSectionComponent;
}

export const Section: React.FC<SectionProps> = (props) => {
    const { children, ..._props } = props;
    const api = useSection(_props);

    return <SectionProvider value={api}>{children}</SectionProvider>;
};
